import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref, watch } from 'vue'

import CareerAiRateLimitBanner from '@/components/CareerAiRateLimitBanner.vue'
import CareerAiServiceMenu from './CareerAiServiceMenu.vue'

type ServiceMenuItem = {
  key: string
  label: string
  description: string
  route: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CareerAiInputArea',
  props: {
  value: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  // 本日の上限に達している。入力自体を止める
  inputDisabled: { type: Boolean, default: false },
  showRateLimitBanner: { type: Boolean, default: false },
  dailyLimit: { type: Number, default: 30 },
  isPrime: { type: Boolean, default: false },
  menuItems: { type: Array as () => ServiceMenuItem[], default: () => [] }
},
  emits: [
  'input',
  'send',
  'composition',
  'cta-click',
  'menu-select'
],
  setup(__props, { expose, emit }) {

const props = __props;




const inputField = ref<HTMLInputElement | null>(null)
const toggleButton = ref<HTMLButtonElement | null>(null)
const serviceMenu = ref<{ focusClose: () => void } | null>(null)
const isMenuOpen = ref(false)

// ＋と入力欄はメニューと入れ替わりで消えるので、開閉のたびにフォーカスの
// 行き先を明示する（移さないと body へ落ちてキーボードで到達できない）。
// マウス操作で枠が見えないようにするのは :focus-visible 側の担当
const openMenu = (): void => {
  isMenuOpen.value = true
  nextTick(() => serviceMenu.value?.focusClose())
}

const closeMenu = (): void => {
  isMenuOpen.value = false
  nextTick(() => toggleButton.value?.focus())
}

const sendDisabled = computed(
  () => !props.value.trim() || props.loading || props.inputDisabled
)

// 表示中の機能（遷移先が無い項目）は閉じるだけ。
// 選んだ項目ごと消えるので、閉じるボタンと同じくフォーカスを＋へ戻す
const onSelect = (item: ServiceMenuItem): void => {
  closeMenu()
  emit('menu-select', item)
}

// サジェストを押したあとに入力欄へ戻すため、親から呼ぶ最小 API。
// メニューを開いていると入力欄自体が無いので、先に閉じる
const focus = (): void => {
  isMenuOpen.value = false
  nextTick(() => inputField.value?.focus())
}

// 応答が始まったら開いたままにしない（入力欄が消えたままになるため）
watch(
  () => props.loading,
  (value) => {
    if (value) isMenuOpen.value = false
  }
)

expose({ focus })

return { __sfc: true,props, emit, inputField, toggleButton, serviceMenu, isMenuOpen, openMenu, closeMenu, sendDisabled, onSelect, focus, CareerAiRateLimitBanner, CareerAiServiceMenu }
}

})